import React from "react";
import { ActiveFilter, FilterProvider } from "~/components/ultra-filter/types";
import { UltraFilter } from "~/components/ultra-filter";
import { useRatesheetAssignableProvider } from "~/filterProviders/useRatesheetAssignableProvider";
import {
  getYesNoFilterValue,
  useShowArchivedProvider,
} from "~/filterProviders/yesNoProviders";
import { FilterOptions } from "./types";

export type FilterFormProps = {
  onFiltersChanged: React.Dispatch<FilterOptions>;
};

export const FilterForm: React.FC<FilterFormProps> = ({ onFiltersChanged }) => {
  const providers = [
    useRatesheetAssignableProvider({
      documentationText: "The ratesheet's assignable filter.",
    }),
    useShowArchivedProvider({
      documentationText: "Whether to show archived ratesheets.",
    }),
  ] as FilterProvider[];

  const onChanged = (filters: ActiveFilter[], searchText: string) => {
    const newFilters = {
      searchText: searchText || null,
      assignable: filters.find((x) => x.type === "assignable")?.value || "All",
      showArchived: getYesNoFilterValue(
        filters.find((x) => x.type === "showArchived")
      ),
    };
    onFiltersChanged(newFilters);
  };

  return (
    <div className="filter-form">
      <UltraFilter
        {...{
          providers,
          onFiltersChanged: onChanged,
          dialogTitle: "Expense Ratesheet Search",
          label: "Type to search expense ratesheets",
        }}
      />
    </div>
  );
};
